import axios from 'axios';
import { colorSchema } from '../schemas/colors';
import { validate } from '../validate';
import { CREATOR_API } from '../creator-api';

async function get() {
  const { data } = await axios.get(CREATOR_API.config.endpoints.colors);
  const errors = [];
  const validated = validate(data, colorSchema, errors);

  return { data: validated, errors };
}

export default { get };
